import { api } from '../../../../api';
import * as ConfigAPI from '../../../../config/api';

// @todo Избавиться от дублей запросов: есть аналогичный запрос для работы с сагами
export const getDealerRegistrationFormRequest = (
  payload: GM.DealerRegistrationForm.Requests.Registration,
) => {
  return api.post(ConfigAPI.registerRestaurateur, payload);
};
